<!-- =========================================================================================
  File Name: SessionAdd.vue
  Description: Session Add Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.border-1 {
  border: 1px solid #cdcdcd;
  padding: 12px;
  border-radius: 5px;
}
ul.streaming-client-wrap {
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid #4c8bf6;
  border-radius: 5px;
}
</style>
<template>
  <form-wizard
    color="rgba(var(--vs-primary), 1)"
    :title="null"
    :subtitle="null"
    finishButtonText="Save & Continue"
    @on-complete="formSubmitted"
    v-if="session_data"
    layout="vertical"
    class="vertical-wizard"
  >
    <tab-content
      title="Session Details"
      class="mb-5"
      :before-change="before_save"
      icon="feather icon-list"
    >
      <!-- Avatar Row -->
      <div class="vx-row">
        <div class="vx-col md:w-1/12 w-full"></div>
        <div class="vx-col md:w-1/1 w-full mb-6">
          <div class="custom-head-wrap">
            <!-- <h2 class="cms-custom-heading">Session Type - {{sessionType.label}}</h2>
              <p class="mt-1 mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p> -->
            <input
              type="text"
              name="Title"
              v-model="session_data.Name"
              v-validate="'required'"
              class="w-full"
              id=""
              value=""
              placeholder="Session Title*"
            />
            <span
              class="text-warning text-sm"
              v-show="session_data.Name.length > 20"
              >For best view, 20 characters recommended ({{
                session_data.Name.length
              }}/20)</span
            >
            <span class="text-danger text-sm" v-show="errors.has('Title')"
              >This field is required</span
            >
            <input
              type="text"
              v-model="session_data.DescriptionShort"
              class="w-full session-desc"
              id=""
              value=""
              placeholder="Session Description (Optional)"
            />
            <span
              class="text-warning text-sm"
              v-show="session_data.DescriptionShort.length > 30"
              >For best view, 30 characters recommended ({{
                session_data.DescriptionShort.length
              }}/30)</span
            >
          </div>
        </div>
        <!-- <div class="vx-col md:w-6/12">
          <div class="single-field">
            <label><b>Title</b></label>
            <vs-input
              class="inputx time-pkr glow"
              name="Title"           
              v-model="session_data.Name"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('Title')">{{
              errors.first("Title")
            }}</span>
          </div>
        </div> -->
        <div class="vx-col md:w-6/12">
          <div class="single-field">
            <label><b>Session Type</b></label>
            <v-select
              class="glow"
              v-model="sessionType"
              :clearable="false"
              :options="[
                { label: 'Custom Url', value: 5 },
                { label: 'In-person', value: 6 },
                { label: 'Live Panel', value: 3 },
                { label: 'On Demand', value: 1 },
                { label: 'Live Stream', value: 2 },
                { label: 'Round Table', value: 4 },
              ]"
            />
          </div>
        </div>
        <div class="vx-col md:w-6/12 w-full mt-5">
          <div class="border-1">
            <div class="flex items-center flex-col sm:flex-row">
              <div class="image-wrap-add-edit mr-4">
                <img :src="imgSrc" class="" style="" />
              </div>
              <!-- <vs-avatar :src="data_local.ProfilePictureURL" size="80px" class="mr-4" /> -->
              <div>
                <p class="text-lg font-medium sm:mt-0"></p>
                <input
                  id="uploadAvatar"
                  type="file"
                  class="hidden"
                  ref="update_avatar_input"
                  @change="update_avatar($event, '200x100', true)"
                  accept="image/*"
                />

                <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
                <vs-button
                  class="mr-4 image-add-btn"
                  @click="$refs.update_avatar_input.click()"
                  >Upload</vs-button
                >
                <!-- <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Change Avatar</vs-button> -->

                <!--<vs-button type="border" color="danger">Remove Avatar</vs-button>-->
              </div>
            </div>
            <p class="mt-2 img-txt">
              Use a high quality image: 960 x 192px (5:1 ratio)
            </p>
          </div>
        </div>
        <div class="vx-col md:w-3/12 w-full mt-5">
          <label>Starts On<span class="essential">*</span></label>
          <flat-pickr
            :config="configdateTimePickerStart"
            name="Starts On"
            v-model="StartDate"
            v-validate="'required'"
            data-vv-validate-on="change"
            placeholder="MM/DD/YYYY HH:MM"
            class="time-pkr"
          />
          <span class="text-danger text-sm" v-show="errors.has('Starts On')"
            >This field is required</span
          >
        </div>
        <div class="vx-col md:w-3/12 w-full mt-5">
          <label>Ends On<span class="essential">*</span></label>
          <flat-pickr
            :config="configdateTimePickerEnd"
            name="Ends On"
            v-model="EndDate"
            v-validate="'required'"
            data-vv-validate-on="change"
            placeholder="MM/DD/YYYY HH:MM"
            class="time-pkr"
          />
          <span class="text-danger text-sm" v-show="errors.has('Ends On')"
            >This field is required</span
          >
        </div>
        <div class="vx-col md:w-6/12 w-full mt-5" v-if="sessionType.value == 3">
          <label>Streaming Client</label>
          <div class="w-full">
            <ul class="streaming-client-wrap">
              <li
                :class="session_data.StreamingClient == 'Zoom' ? 'active' : ''"
              >
                <vs-radio
                  class="ml-3"
                  v-model="session_data.StreamingClient"
                  vs-value="Zoom"
                  name="StreamingClient"
                  color="#ffffff"
                  @change="setZoomRtmp(session_data.StreamingClient)"
                  >Zoom Client</vs-radio
                >
              </li>
              <li
                :class="
                  session_data.StreamingClient == 'ZoomWeb' ? 'active' : ''
                "
              >
                <vs-radio
                  class="ml-3"
                  v-model="session_data.StreamingClient"
                  vs-value="ZoomWeb"
                  name="StreamingClient"
                  color="#ffffff"
                  @change="setZoomRtmp(session_data.StreamingClient)"
                  >Zoom Web</vs-radio
                >
              </li>
              <li
                :class="session_data.StreamingClient == 'Web' ? 'active' : ''"
              >
                <vs-radio
                  v-model="session_data.StreamingClient"
                  vs-value="Web"
                  name="StreamingClient"
                  color="#ffffff"
                  @change="setZoomRtmp(session_data.StreamingClient)"
                  >Web</vs-radio
                >
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- tab 1 content -->
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mt-5">
          <label>Location</label>
          <vs-input
            class="inputx time-pkr"
            placeholder="Location"
            v-model="session_data.Location.LocationName"
          />
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5">
          <label>Select Track</label>
          <div class="track-wrapper sessionadd">
            <v-select
              class="track-select"
              label="TrackName"
              v-model="session_data.Track"
              :options="trackList"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
            <vs-button color="primary" type="filled" @click="popupActive = true"
              >Add</vs-button
            >
            <div class="track-popup">
              <vs-popup
                class="holamundo"
                title="Add New Track"
                :active.sync="popupActive"
              >
                <div class="add-track-inner-section">
                  <vs-input
                    class="inputx input-track-name w-full"
                    placeholder="Track Name"
                    v-model="TrackName"
                  />
                  <!--<vs-input class="inputx input-track-name w-full" placeholder="ColorCode" v-model="ColorCode" />-->
                  <div class="color-choose">
                    <label>Select color code</label>
                    <input v-model="ColorCode" type="color" />
                  </div>
                  <vs-button
                    color="rgb(76, 139, 246)"
                    type="filled"
                    @click="addTrack"
                    >Add</vs-button
                  >
                </div>
              </vs-popup>
            </div>
          </div>
        </div>



        <div class="vx-col md:w-1/2 w-full mt-5" v-if="!disablspeaker && sessionType.value != 6">
          <label v-if="sessionType.value == 3"
            >Select Speakers<span class="essential">*</span></label
          >
          <label v-else>Select Speakers</label>
          <div class="track-wrapper">
            <v-select
              multiple
              :closeOnSelect="false"
              label="Name"
              v-model="session_data.MappedSpeakers"
              :options="speakerList"
              :OnChange="setHost()"
              v-on:input="limiter"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              name="Speaker"
              v-validate="mandatespeaker ? 'required' : ''"
              :disabled="disablspeaker"
              class="track-select"
            />
            <vs-button
              color="primary"
              type="filled"
              @click="popupSpeakerAdd = true"
              >Add</vs-button
            >
          </div>
          <span class="text-danger text-sm" v-show="errors.has('Speaker')">{{
            errors.first("Speaker")
          }}</span>
        </div>

        <div
          class="vx-col md:w-1/2 w-full mt-5"
          v-if="!disablhost || sessionType.value == 5"
        >
          <label v-if="sessionType.value == 5">Select A Host</label>
          <label v-else>Select A Host<span class="essential">*</span></label>
          <v-select
            v-if="sessionType.value == 5"
            multiple
            :closeOnSelect="false"
            label="Name"
            v-model="session_data.MappedHosts"
            :options="attendessList"
            name="Host"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-validate="{ required: mandatehost, length: 1 }"
          />

          <v-select
            v-else
            multiple
            :closeOnSelect="false"
            label="Name"
            v-model="session_data.MappedHosts"
            :options="attendessList"
            name="Host"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-validate="{ required: mandatehost, length: 1 }"
            :disabled="disablhost"
          />
          <span class="text-danger text-sm" v-show="errors.has('Host')">{{
            errors.first("Host")
          }}</span>
        </div>

        <div
          class="vx-col md:w-1/2 w-full mt-5"
          v-if="
            (!disablhost && session_data.StreamingClient == 'Web') ||
            sessionType.value == 5
          "
        >
          <label>Select A Co-Host</label>
          <v-select
            label="Name"
            v-model="session_data.MappedCoHost"
            :options="attendessList"
            name="CoHost"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
        </div>
        <!-- <div class="vx-col md:w-1/2 w-full mt-5">
            <label>Short Description</label>
            <vs-input
              class="inputx time-pkr"
              placeholder="Short Description"
              v-model="session_data.DescriptionShort"
            />
          </div>  -->

        <div
          class="vx-col md:w-6/12 w-full mt-5"
          v-if="
            sessionType.value == 3 &&
            session_data.StreamingClient.includes('Zoom')
          "
        >
          <div class="stream-enable-head">
            <label>
              Enable RTMP Stream
              <vx-tooltip
                text="Enabling this will create a Zoom meeting where Speakers join using Zoom, while Attendees view the Zoom video stream on the Virtual events Web / App. Speakers can live interact via QnA, Chat and Polls with attendees."
                position="bottom"
              >
                <feather-icon class="" icon="InfoIcon" />
              </vx-tooltip>
            </label>
          </div>
          <div class="w-full mt-4">
            <vs-switch v-model="session_data.IsZoomRTMP" />
          </div>
        </div>
        <div
          class="vx-col md:w-6/12 w-full mt-5"
          v-if="sessionType.value == 3 && session_data.StreamingClient == 'Web'"
        >
          <div class="stream-enable-head">
            <label>
              Enable RTMP Stream
              <vx-tooltip
                text="Enabling this will create a meeting where Speakers join using agora, while Attendees view the video stream on the Virtual events Web / App. Speakers can live interact via QnA, Chat and Polls with attendees."
                position="bottom"
              >
                <feather-icon class="" icon="InfoIcon" />
              </vx-tooltip>
            </label>
          </div>
          <div class="w-full mt-4">
            <vs-switch disabled v-model="session_data.IsRTMP" />
          </div>
        </div>

                <div
          class="vx-col md:w-6/12 w-full mt-5"
          v-if="sessionType.value == 3 && session_data.StreamingClient == 'Web'"
        >
          <div class="stream-enable-head">
            <label>
              Enable Breakout Room 
            </label>
          </div>
          <div class="w-full mt-4">
            <vs-switch v-model="session_data.EnableBreakoutRoom" @change="toggleBreakOut()"/>
          </div>
        </div>
        <div
          class="vx-col md:w-6/12 w-full mt-5"
          v-if="
            sessionType.value == 3 &&
            session_data.StreamingClient.includes('Zoom') &&
            !session_data.IsZoomRTMP
          "
        >
          <label
            >Select Available Webinar License<span class="essential"
              >*</span
            ></label
          >
          <v-select
            v-model="session_data.WebinarCapacity"
            :options="ZoomPlans"
            name="WebinarCapacity"
            v-validate="
              session_data.StreamingClient.includes('Zoom') ? 'required' : ''
            "
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('WebinarCapacity')"
            >This field is required</span
          >
        </div>

        <div class="vx-col md:w-1/2 w-full mt-5">
          <label>Session Visible for</label>
          <v-select
            v-model="session_data.SessionVisibleFor"
            :options="[
              { label: 'Everyone', value: 1 },
              { label: 'User Group', value: 2 },
              { label: 'List of Attendees', value: 3 },
            ]"
          />
        </div>
        <div
          class="vx-col md:w-1/2 w-full mt-5"
          v-if="
            session_data.SessionVisibleFor &&
            session_data.SessionVisibleFor.value == 2
          "
        >
          <label>Select Groups</label>
          <v-select
            multiple
            v-model="SelectedGroups"
            :options="GroupList"
            label="GroupName"
            name="Groups"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('Groups')"
            >This field is required</span
          >
        </div>
        <div
          class="vx-col md:w-1/2 w-full mt-5"
          v-if="
            session_data.SessionVisibleFor &&
            session_data.SessionVisibleFor.value == 3
          "
        >
          <label>Select Attendees</label>
          <v-select
            multiple
            v-model="SelectedAttendees"
            :options="AttendeeList"
            label="Name"
            name="AttendeeList"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('AttendeeList')"
            >This field is required</span
          >
        </div>
        <div
          class="vx-col md:w-1/2 w-full mt-5"
          v-if="['EDU', 'UAT'].includes(Environment)"
        >
          <label>Select Batch</label>
          <v-select
            v-model="Batch"
            :options="SessionBatchList"
            label="BatchName"
          />
        </div>
      </div>
      <div class="vx-row mt-5" v-if="sessionType.value == 4">
        <div class="vx-col md:w-1/1 w-full">
          <div class="custom-head-wrap">
            <h2 class="cms-custom-heading">Round Table Mapping</h2>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div
          class="vx-col md:w-12/12 w-full mt-5 mb-4"
          v-if="sessionType.value == 4"
        >
          <div>
            <ul class="streaming-client-wrap">
              <li
                :class="
                  session_data.MapExistingRoundTableGroup == 'Existing'
                    ? 'active'
                    : ''
                "
              >
                <vs-radio
                  class="ml-3"
                  v-model="session_data.MapExistingRoundTableGroup"
                  vs-value="Existing"
                  color="#ffffff"
                  >Existing Round Table Group</vs-radio
                >
              </li>
              <li
                :class="
                  session_data.MapExistingRoundTableGroup == 'New'
                    ? 'active'
                    : ''
                "
              >
                <vs-radio
                  class="ml-3"
                  v-model="session_data.MapExistingRoundTableGroup"
                  vs-value="New"
                  color="#ffffff"
                  >Create New Round Tables</vs-radio
                >
              </li>
            </ul>
            <!-- <vs-switch
              v-model="session_data.MapExistingRoundTableGroup"
            >
            </vs-switch> -->
          </div>
        </div>
        <div
          class="vx-col md:w-1/2 w-full mt-5"
          :style="session_data.RTStreamingClient 
            != 'Web' ? 'display:block':'display:none'"
          v-if="
            sessionType.value == 4 &&
            session_data.MapExistingRoundTableGroup == 'New' 
          "
        >
          <label>Approval Type</label>
          <v-select
            class="mt-3"
            label="Name"
            :clearable="false"
            :options="[
              { Name: 'Open Meeting', id: 2 },
              { Name: 'Need Registration', id: 0 },
            ]"
            :reduce="(option) => option.id"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="session_data.approval_type"
          />
        </div>
        <div
          class="vx-col md:w-1/2 w-full mt-5"
          v-if="
            sessionType.value == 4 &&
            session_data.MapExistingRoundTableGroup == 'New'
          "
        >
          <label>Round Table Streaming Client</label>
          <div class="w-full mt-3">
            <ul class="streaming-client-wrap">
              <li
                :class="
                  session_data.RTStreamingClient == 'Zoom' ? 'active' : ''
                "
              >
                <vs-radio
                  class="ml-3"
                  v-model="session_data.RTStreamingClient"
                  vs-value="Zoom"
                  color="#ffffff"
                  >Zoom Client</vs-radio
                >
              </li>
              <li
                :class="
                  session_data.RTStreamingClient == 'ZoomWeb' ? 'active' : ''
                "
              >
                <vs-radio
                  class="ml-3"
                  v-model="session_data.RTStreamingClient"
                  vs-value="ZoomWeb"
                  color="#ffffff"
                  >Zoom Web</vs-radio
                >
              </li>
              <li
                :class="session_data.RTStreamingClient == 'Web' ? 'active' : ''"
              >
                <vs-radio
                  v-model="session_data.RTStreamingClient"
                  vs-value="Web"
                  color="#ffffff"
                  >Web</vs-radio
                >
              </li>
            </ul>
          </div>
        </div>
        <div
          class="vx-col md:w-1/3 w-full mt-5"
          v-if="
            sessionType.value == 4 &&
            session_data.MapExistingRoundTableGroup == 'New'
          "
        >
          <label>Round Table Type</label>
          <div class="w-full mt-5">
            <vs-radio
              v-model="session_data.TableType"
              vs-value="Open"
              name="TableType"
              >Open</vs-radio
            >
            <vs-radio
              class="ml-3"
              v-model="session_data.TableType"
              vs-value="Pre_assigned"
              name="TableType"
              >Pre-assigned</vs-radio
            >
          </div>
        </div>
        <!-- <div
          class="vx-col md:w-1/3 w-full mt-5"
          v-if="
            sessionType.value == 4 &&
            session_data.MapExistingRoundTableGroup == 'New'
            && !DisableSpectate
          "
        >
          <label>Spectate</label>
          <div class="mt-4">
            <vs-switch
              v-model="session_data.Spectate"
              name="Spectate"
              :disabled="DisableSpectate"
            >
            </vs-switch>
          </div>
        </div> -->
        <div
          class="vx-col md:w-1/3 w-full mt-5"
          v-if="
            sessionType.value == 4 &&
            session_data.MapExistingRoundTableGroup == 'New'
          "
        >
          <div class="stream-enable-head">
            <label>
              Select Round Table Host
              <span class="rqrd">*</span>
              <vx-tooltip
                text="Selected Host will be common for all the tables generated."
                position="bottom"
              >
                <feather-icon class="" icon="InfoIcon" />
              </vx-tooltip>
            </label>
          </div>

          <v-select
            class="mt-3"
            label="Email"
            :options="AttendeeList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            name="RTHost"
            v-model="session_data.RTHost"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('RTHost')"
            >This field is required</span
          >
        </div>
        <div
          class="vx-col md:w-1/2 w-full mt-5 seats-number"
          v-if="
            sessionType.value == 4 &&
            session_data.MapExistingRoundTableGroup == 'New'
          "
        >
          <label>No of seats per Table</label>
          <vs-input-number
            class="inputx w-full mt-3"
            v-model="session_data.NumberOfSeatsPerTable"
            :min="MinNumberOfSeatsPerTable"
            :max="MaxNumberOfSeatsPerTable"
            step="1"
            name="Number Of Seats Per Table"
            v-validate="'required|min_value:2'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('Number Of Seats Per Table')"
            >{{ errors.first("Number Of Seats Per Table") }}</span
          >
        </div>
        <div
          class="vx-col md:w-1/2 w-full mt-5 seats-number"
          v-if="
            sessionType.value == 4 &&
            session_data.MapExistingRoundTableGroup == 'New'
          "
        >
          <div class="stream-enable-head">
            <label
              >No of Tables
              <vx-tooltip
                text="Table group will be created by name of the session. Table will be mapped under the group eg: Table 1, Table 2 ..."
                position="bottom"
              >
                <feather-icon class="" icon="InfoIcon" />
              </vx-tooltip>
            </label>
          </div>
          <vs-input-number
            class="inputx w-full mt-3"
            v-model="session_data.NumberOfTables"
            min="1"
            step="1"
            name="Number Of Tables"
            v-validate="'required|min_value:1'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('Number Of Tables')"
            >{{ errors.first("Number Of Tables") }}</span
          >
        </div>
          <div class="vx-col md:w-1/2 w-full mt-4"  v-if="
            sessionType.value == 4 &&
            session_data.MapExistingRoundTableGroup == 'New'
          ">
        <label>Enable Breakout Room</label>
        
        <div class="mt-4">
          <vs-switch v-model="session_data.EnableBreakoutRoom" name="EnableBreakoutRoom">
            <span slot="true">True</span>
            <span slot="false">False</span>
          </vs-switch>
        </div>
      </div>
        <div class="vx-col md:w-1/1 w-full">
          <div
            class="map-round-table-wrapper w-full mt-5"
            v-if="
              sessionType.value == 4 &&
              session_data.MapExistingRoundTableGroup == 'Existing'
            "
          >
            <label>Map to Round Table Group</label>
            <ul>
              <li
                v-for="rt in roundtableList"
                :class="
                  session_data.RoundTables &&
                  rt.TopicId == session_data.RoundTables.TopicId
                    ? 'active-round-table-group'
                    : ''
                "
              >
                <label>
                  <input
                    class="mr-5"
                    name="RoundTableTopic"
                    type="radio"
                    v-model="session_data.RoundTables"
                    v-validate="
                      session_data.MapExistingRoundTableGroup == 'Existing'
                        ? 'required'
                        : ''
                    "
                    v-bind:value="rt"
                    v-bind:checked="
                      session_data.RoundTables &&
                      rt.TopicId == session_data.RoundTables.TopicId
                    "
                  />
                  {{ rt.TopicName }}
                </label>
              </li>
            </ul>
            <span
              class="text-danger text-sm"
              v-show="errors.has('RoundTableTopic')"
              >This field is required</span
            >
          </div>
        </div>
      </div>
    </tab-content>

    <template slot="footer" scope="props">
      <div class="wizard-footer-left">
        <vs-button
          v-if="props.activeTabIndex == 0"
          @click.native="$router.push('/event/sessions')"
          >Back to List</vs-button
        >
        <vs-button @click.native="props.prevTab()" v-else>Previous</vs-button>
      </div>
      <div class="wizard-footer-right">
        <vs-button
          v-if="!props.isLastStep"
          @click.native="props.nextTab()"
          class="wizard-footer-right"
          >Next</vs-button
        >
        <vs-button
          v-else
          @click.native="before_save"
          class="wizard-footer-right finish-button"
          color="success"
          >Save &amp; Continue</vs-button
        >
      </div>
    </template>

    <vs-popup class="holamundo" title="Edit Url" :active.sync="popupActive2">
      <div class="add-track-inner-section">
        <vs-input
          class="inputx time-pkr"
          placeholder=""
          v-model="editUrlText"
        />
        <vs-button color="rgb(76, 139, 246)" type="filled" @click="editUrl"
          >Save</vs-button
        >
      </div>
    </vs-popup>
    <vs-popup
      class="holamundo addspeaker-popup"
      title="Add New Speaker"
      :active.sync="popupSpeakerAdd"
    >
      <form
        @submit.prevent="validateForm('form-speaker')"
        data-vv-scope="form-speaker"
      >
        <div class="row">
          <div class="vx-col w-full">
            <vs-input
              class="inputx input-track-name w-full"
              placeholder="First Name"
              v-model="SpeakerObj.FirstName"
              name="FirstName"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('form-speaker.FirstName')"
              >The First Name field is required</span
            >
          </div>
          <div class="vx-col w-full mt-5">
            <vs-input
              class="inputx input-track-name w-full"
              placeholder="Last Name"
              v-model="SpeakerObj.LastName"
              name="LastName"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('form-speaker.LastName')"
              >The Last Name field is required</span
            >
          </div>
          <div class="vx-col w-full mt-5">
            <vs-input
              class="inputx input-track-name w-full"
              placeholder="Email"
              v-model="SpeakerObj.Email"
              name="Email"
              v-validate="'required|email'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('form-speaker.Email')"
              >{{ errors.first("form-speaker.Email") }}</span
            >
          </div>
          <div class="vx-col w-full mt-5">
            <vs-button
              color="rgb(76, 139, 246)"
              type="filled"
              @click="addSpeaker"
              >Add</vs-button
            >
          </div>
        </div>
      </form>
    </vs-popup>
    <vs-popup
      class="holamundo registrationType-popup"
      title="Crop Image"
      :active.sync="popupCropper"
      fullscreen="fullscreen"
      v-if="cropImageUrl"
    >
      <h5>
        Aspect Ratio for this image is {{ displayImageRatio }}. To crop this
        image, simply drag and click Upload
      </h5>
      <photowall-resize-component
        :key="resetCropper"
        v-bind:aspectValue="imageRatio"
        :sourceImage="cropImageUrl"
        @croppedImagePath="croppedImagePath"
      />
    </vs-popup>
  </form-wizard>
</template>



<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment-timezone";
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import XLSX from "xlsx";
import draggable from "vuedraggable";
import CKEditor from "ckeditor4-vue";
import CKconfig from "@/assets/ckeditor-config.ts";
// Store Module
import moduleSessionManagement from "@/store/session-management/moduleSessionManagement.js";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import moduleSpeakerManagement from "@/store/speaker-management/moduleSpeakerManagement.js";
import moduleTrackManagement from "@/store/track-management/moduleTrackManagement.js";
import moduleRoundTableManagement from "@/store/roundtable-management/moduleRoundtableManagement.js";
import moduleClientManagement from "@/store/client-management/moduleClientManagement.js";
import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
import moduleAgendaManagement from "@/store/agenda-management/moduleAgendaManagement.js";
import PhotowallResizeComponent from "../photowall/PhotowallResizeComponent.vue";
import con from "@/firebase/firebaseInit.ts";
import ls from "@/common/localStorage";

var cn = ls.getSessionEventCollectionName();
let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id");
let Session_EventStartDate = ls.getSessionValueByKey("Session_EventStartDate");
let Session_EventEndDate = ls.getSessionValueByKey("Session_EventEndDate");
let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
var vm;
export default {
  components: {
    FormWizard,
    TabContent,
    flatPickr,
    "v-select": vSelect,
    quillEditor,
    draggable,
    ckeditor: CKEditor.component,
    PhotowallResizeComponent,
  },
  props: {
    /*data: {
      type: Object,
      required: true
    }*/
    //session_data: null
  },
  data() {
    return {
      Environment: con.Environment,
      editorConfig: CKconfig.editorConfig,
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fon-air-white.png?alt=media", // "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT_C1591904892446E1591907102804%2FSession%2FSettings%2F1600099550726_2048x2732.jpg?alt=media&token=82631343-f46a-4c56-b5ef-d518a63c363c",
      attendessList: [],
      ResourceFiles: [],
      speakerList: [],
      trackList: [],
      roundtableList: [],
      session_data: null,
      SessionId: 0,
      session_not_found: false,
      MaxNumberOfSeatsPerTable: 12,
      MinNumberOfSeatsPerTable: 2,
      DisableSpectate: false,
      DefaultNotificationMessage:
        "This session is about to end in {{countdown}}",
      DisplayBeforeSessionEndSecs: null,
      StartDate: null,
      EndDate: null,
      LSDateTime: null,
      configdateTimePicker: {
        minDate: new Date(),
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y H:i",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: true,
      },
      configdateTimePickerStart: {
        minDate: new Date(),
        maxDate: null,
        onChange: function (val) {
          if (val) vm.configdateTimePickerEnd.minDate = new Date(val);
        },
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y h:i K",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: false,
      },
      configdateTimePickerEnd: {
        minDate: new Date(),
        maxDate: null,
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y h:i K",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: false,
      },
      configdateTimePickerTime: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        time_24hr: true,
      },
      editorOption: {
        theme: "bubble",
      },
      ZoomPlans: [],
      TrackName: null,
      color: null,
      ColorCode: null,
      popupActive: false,
      popupActive2: false,
      popupSpeakerAdd: false,
      tabIndex: 0,
      activeTabIndex: 0,
      PlanDetails: {
        MaxAttendeesPerClient: 10,
        EnhancedEventBranding: false,
        AllowSessionOnDemandVideo: false,
        AllowSessionLiveSimulated: false,
        AllowSessionRoundtable: false,
        ShowBrandingEventSetup: false,
        MaxEventDays: 2,
        EventAccessPostEvent: false,
        EnhancedRegistration: false,
        ContractStartDate: new Date(),
        ContractEndDate: new Date(),
        PricePerExtraAttendee: 100,
      },
      EventData: null,
      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0,
      slectedTab: 0,
      editUrlText: null,
      sessionType: { label: "Live Panel", value: 3 },
      disablhost: false,
      disablspeaker: false,
      mandatehost: false,
      mandatespeaker: false,
      SpeakerObj: {
        Company: null,
        CreatedDate: new Date(),
        Designation: null,
        Email: null,
        IsAttendee: true,
        IsSpeaker: true,
        FirstName: null,
        Group: null,
        LastModifiedDate: new Date(),
        LastName: null,
        Phone: null,
        Profile: null,
        IsPublished: true,
        Website: null,
      },
      Batch: null,
      SessionBatchList: [],
      GroupList: [],
      SelectedGroups: [],
      AttendeeList: [],
      SelectedAttendees: [],
      Session_LocationType: ls.getSessionValueByKey("Session_LocationType"),
      imageRatio: 5 / 1,
      cropImageUrl: null,
      popupCropper: false,
      resetCropper: 0,
      displayImageRatio: "5 / 1",
      uploadedFile: null,
    };
  },
  watch: {
    activeTab() {
      this.fetch_session_data();
    },
    sessionType(obj) {
      this.errors.clear();
      if(!obj){
        this.$router.push('/event/sessions');

      }
      if (obj.value == 1 || obj.value == 2 || obj.value == 5) {
        this.disablhost = true;
        this.disablspeaker = false;
        this.mandatehost = false;
        this.mandatespeaker = false;
      } else if (obj.value == 3) {
        this.disablhost = false;
        this.disablspeaker = false;
        this.mandatehost = true;
        this.mandatespeaker = true;
      } else if (obj.value == 4) {
        this.disablhost = true;
        this.disablspeaker = true;
        this.mandatehost = false;
        this.mandatespeaker = false;
        this.session_data.MapExistingRoundTableGroup = "Existing";
      }

      if (obj.value == 3) {
        this.session_data.StreamingClient = "Zoom";
        this.session_data.IsZoomRTMP = true;
        this.session_data.IsRTMP = false;
      } else {
        this.session_data.StreamingClient = "Web";
        this.session_data.IsZoomRTMP = false;
        this.session_data.IsRTMP = false;
      }
    },
    "session_data.RTStreamingClient"(val) {
      if (val.includes("Zoom")) {
        this.session_data.NumberOfSeatsPerTable = 300;
        this.MaxNumberOfSeatsPerTable = 300;
        this.session_data.Spectate = false;
        this.DisableSpectate = true;
      } else {
        this.session_data.NumberOfSeatsPerTable = 8;
        this.MaxNumberOfSeatsPerTable = 12;
        this.DisableSpectate = false;
      }
    },
    "session_data.TableType"(val) {
      if (val == "Open") {
        this.DisableSpectate = false;
      } else {
        this.session_data.Spectate = false;
        this.DisableSpectate = true;
      }
    },
  },
  methods: {
    toggleBreakOut(){
      if(this.session_data.EnableBreakoutRoom){
        this.session_data.IsRTMP = false;
      }else{
         this.session_data.IsRTMP = true;
      }
    },


    setZoomRtmp(data) {
      if (data == "Web") {
        this.session_data.IsZoomRTMP = false;
        this.session_data.IsRTMP = true;
      } else {
        this.session_data.IsZoomRTMP = true;
        this.session_data.IsRTMP = false;
      }
    },
    limiter(e) {
      let attcnt = 12;
      if (e.length > attcnt) {
        e.pop();
        this.$vs.notify({
          color: "warning",
          position: "top-center",
          //title: "Round Table",
          text: "You can only select " + attcnt + " users!",
        });
      }
    },
    croppedImagePath(blob) {
      //this.imgSrc = blob;
      this.popupCropper = false;
      if (this.uploadedFile)
        vm.uploadImage(blob, `${cn}/Session/LogoImage/`, this.uploadedFile);
    },
    update_avatar(input, fileWH, checkRatio = false) {
      debugger;
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        this.uploadedFile = file;
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let dimension = fileWH.split("x");
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          const reader = new FileReader();
          reader.onload = (e) => {
            //vm.imgSrc = e.target.result;
            vm.resetCropper += 1;
            vm.cropImageUrl = null;
            vm.cropImageUrl = e.target.result;
            vm.popupCropper = true;
          };
          reader.readAsDataURL(input.target.files[0]);
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
    uploadImage(fileBlob, target, file) {
      this.$vs.loading();
      this.$store
        .dispatch("sessionManagement/uploadFiles", [
          { blob: fileBlob, target: target, name: file.name, type: file.type },
        ])
        .then((res) => {
          this.$vs.loading.close();
          if (res.data.length && res.data[0].status == "fulfilled") {
            this.session_data.SessionLogo = res.data[0].value.url;
            this.imgSrc = res.data[0].value.url;
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              //title: "Session",
              text: "File not uploaded!",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            //title: "Session",
            text: "Something went wrong!",
          });
        });
    },
    before_save() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          resolve(result);
          if (result) vm.formSubmitted();
        });
      });
    },
    fetch_session_data() {
      this.$store
        .dispatch("sessionManagement/fetchSession", null)
        .then((res) => {
          this.session_data = res.data;
          this.session_data.MapExistingRoundTableGroup =
            res.data.MapExistingRoundTableGroup == true ? "Existing" : "New";
          this.session_data.StreamingClient =
            this.sessionType.value == 3 ? res.data.StreamingClient : "Web";
          //this.DisplayBeforeSessionEndSecs = res.data.DisplayBeforeSessionEndSecs ? this.getTimeFromSecond(res.data.DisplayBeforeSessionEndSecs) : null
          this.slectedTab = this.session_data.TypeID - 1;
          this.configdateTimePickerStart.minDate = new Date(
            Session_EventStartDate
          );
          this.configdateTimePickerStart.maxDate = new Date(
            Session_EventEndDate
          );
          this.configdateTimePickerEnd.minDate = new Date(
            Session_EventStartDate
          );
          this.configdateTimePickerEnd.maxDate = new Date(Session_EventEndDate);
          this.configdateTimePicker.minDate = new Date(Session_EventStartDate);
          this.configdateTimePicker.maxDate = new Date(Session_EventEndDate);

          if (new Date(Session_EventStartDate) > new Date()) {
            this.StartDate = new Date(Session_EventStartDate);
          } else {
            this.StartDate = new Date();
            this.configdateTimePickerEnd.minDate = new Date();
          }

          this.sessionType = this.$route.params.sessionType;
          /*if(res.data.SessionTypeDetails.TypeID == 1)
          {
            this.activeTab = 0
          }
          else if(res.data.SessionTypeDetails.TypeID == 2)
          {
            this.activeTab = 2
          }
          else if(res.data.SessionTypeDetails.TypeID == 3)
          {
            this.activeTab = 3
          }
          else if(res.data.SessionTypeDetails.TypeID == 4)
          {
            this.activeTab = 4
          }
          else if(res.data.SessionTypeDetails.TypeID == 5)
          {
            this.activeTab = 1
          }   */
        })
        .catch((err) => {
          /*if (err.response.status === 404) {
            this.session_not_found = true;
            return;
          }
          console.error(err);*/
        });
    },
    fetchClientPlanDetails() {
      this.$store
        .dispatch("clientManagement/fetchClientPlanDetails", Session_Client_Id)
        .then((res) => {
          if (res.PlanDetails) {
            this.PlanDetails = res.PlanDetails;
          }
        });
    },
    getAttendees() {
      this.$store.dispatch("attendeeManagement/fetchAttendees").then((res) => {
        this.AttendeeList = res.map((row) => {
          return {
            AttendeeId: row.AttendeeId,
            Email: row.Email,
            FirstName: row.FirstName,
            LastName: row.LastName,
            Name: row.Name,
          };
        });
      });
    },
    setHost() {
      this.attendessList = this.session_data.MappedSpeakers;
      //console.log('hello' + this.speakerList)
    },
    getSpeakers() {
      this.$store.dispatch("speakerManagement/fetchSpeakers").then((res) => {
        this.speakerList = [];
        for (let i = 0; i < res.length; i++) {
          this.speakerList.push({
            AttendeeId: res[i].SpeakerId,
            Company: res[i].Company,
            Designation: res[i].Designation,
            Email: res[i].Email,
            FirstName: res[i].FirstName,
            LastName: res[i].LastName,
            Name: res[i].Name,
            Phone: res[i].Phone,
            ProfilePictureURL: res[i].ProfilePictureURL
              ? res[i].ProfilePictureURL
              : "",
          });
        }
      });
    },
    getTracks() {
      this.$store
        .dispatch("trackManagement/fetchTracksDropdown")
        .then((res) => {
          this.trackList = res;
        });
    },
    getRoundTables() {
      this.$store
        .dispatch("roundtableManagement/fetchRoundTableTopicDropdown")
        .then((res) => {
          this.roundtableList = res;
        });
    },
    deleteFile(file) {
      let name = "";
      if (file.name) {
        name = file.name;
      }
      let index = this.session_data.Resources.indexOf(name);
      this.session_data.Resources.splice(index, 1);
      let index2 = this.ResourceFiles.indexOf(name);
      this.ResourceFiles.splice(index2, 1);
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    fetch_event_data() {
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      this.$store
        .dispatch("eventManagement/fetchEvent", Session_Event_Id)
        .then((res) => {
          this.EventData = res.data;
        });
    },
    getTimeFromSecond: function (given_seconds) {
      let dateObj = new Date(given_seconds * 1000);
      let hours = dateObj.getUTCHours();
      let minutes = dateObj.getUTCMinutes();
      let seconds = dateObj.getSeconds();

      let timeString =
        hours.toString().padStart(2, "0") +
        ":" +
        minutes.toString().padStart(2, "0") +
        ":" +
        seconds.toString().padStart(2, "0");
      return timeString;
    },
    formSubmitted() {
      this.$vs.loading();
      /*this.session_data.StartDate = this.StartDate;
      this.session_data.EndDate = this.EndDate;
      this.session_data.LSDateTime = this.LSDateTime;*/
      //this.session_data.SessionLogo = this.imgSrc;
      this.session_data.StartDate = this.GetTimeByZone(
        this.StartDate,
        Session_Event_TZ
      );
      this.session_data.EndDate = this.GetTimeByZone(
        this.EndDate,
        Session_Event_TZ
      );
      /*this.session_data.DisplayBeforeSessionEndSecs = null
      if(this.DisplayBeforeSessionEndSecs)
      {
        let a = this.DisplayBeforeSessionEndSecs.split(':');
        this.session_data.DisplayBeforeSessionEndSecs = (+a[0]) * 60 * 60 + (+a[1]) * 60;
      }*/

      if (this.LSDateTime) {
        this.session_data.LSDateTime = this.GetTimeByZone(
          this.LSDateTime,
          this.EventData.TimeZone
        );
      }
      if (this.session_data.MapExistingRoundTableGroup == "Existing") {
        this.session_data.MapExistingRoundTableGroup = true;
      } else {
        this.session_data.MapExistingRoundTableGroup = false;
      }
      this.session_data.ResourceFiles = this.ResourceFiles;
      this.ResourceFiles = [];
      if (this.SessionId) {
        this.$store
          .dispatch("sessionManagement/updateSession", {
            id: this.SessionId,
            data: this.session_data,
            SelectedGroups: this.SelectedGroups,
            SelectedAttendees: this.SelectedAttendees,
            Batch: this.Batch,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Session",
              text: "Session updated successfully.",
            });
            this.$vs.loading.close();
            this.$router.push("/event/sessions/");
            if (res.status == 200) {
              //this.$router.push('/event/sessions');
            }
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        this.session_data.TypeID = this.sessionType.value;
        this.$store
          .dispatch("sessionManagement/addSession", {
            data: this.session_data,
            SelectedGroups: this.SelectedGroups,
            SelectedAttendees: this.SelectedAttendees,
            Batch: this.Batch,
          })
          .then((res) => {
            //alert(res.message)

            this.$vs.loading.close();
            if (res.status == 200) {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Session",
                text: "Session created successfully.",
              });
              //this.$router.push('/event/sessions');
              this.$router.push({
                name: "session-edit",
                params: { sessionId: res.SessionId, activeWizard: 1 },
              });
              this.SessionId = res.SessionId;
            }
            if (res.status == 500) {
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                title: "Session",
                text: res.message,
              });
            }
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      }
    },
    addTrack() {
      /* eslint-disable */
      if (!this.TrackName) return;

      this.$store
        .dispatch("trackManagement/addTrackFromPopup", {
          TrackName: this.TrackName,
          ColorCode: this.ColorCode,
        })
        .then((res) => {
          alert(res.message);
          if (res.status == 200) {
            this.TrackName = "";
            this.ColorCode = "";
            this.popupActive = false;
            this.getTracks();
          }
        })
        .catch((err) => {
          //console.error(err)
        });
    },
    addSpeaker() {
      this.$validator.validateAll("form-speaker").then((result) => {
        if (result) {
          this.$vs.loading();
          this.$store
            .dispatch("speakerManagement/addSpeaker", {
              data: this.SpeakerObj,
            })
            .then((res) => {
              this.$vs.loading.close();
              if (res.status == 200) {
                vm.popupSpeakerAdd = false;
                vm.getSpeakers();
                this.$vs.notify({
                  color: "success",
                  position: "top-center",
                  title: "Speaker",
                  text: "Speaker created successfully.",
                });
              } else {
                this.$vs.notify({
                  color: "warning",
                  position: "top-center",
                  title: "Speaker",
                  text: res.message,
                });
              }
            });
        }
      });
    },
    editUrl() {
      this.popupActive2 = false;
      this.session_data.IsManualUrl = true;
      if (this.session_data.TypeID == 1)
        this.session_data.ODVideoURL = this.editUrlText;
      else if (this.session_data.TypeID == 2)
        this.session_data.LSVideoURL = this.editUrlText;
      this.editUrlText = null;
    },
    getSessionBatches() {
      if (["EDU", "UAT"].includes(this.Environment)) {
        this.$store
          .dispatch("sessionManagement/fetchSessionBatches")
          .then((res) => {
            this.SessionBatchList = res;
          });
      }
    },
  },
  mounted() {},
  created() {
    vm = this;
    //debugger;
    // Register Module SessionManagement Module
    if (!moduleSessionManagement.isRegistered) {
      this.$store.registerModule("sessionManagement", moduleSessionManagement);
      moduleSessionManagement.isRegistered = true;
    }
    this.fetch_session_data();
    this.getSessionBatches();
    this.$store.dispatch("sessionManagement/ZoomGetPlanUssage").then((res) => {
      //this.ZoomPlans = res.plan_webinar ? res.plan_webinar : [];
      this.ZoomPlans.push(500);
      if (res.plan_webinar) {
        res.plan_webinar.filter((plan) => {
          if (Number(plan.hosts) > 0) {
            if (plan.type == "webinar100_monthly") this.ZoomPlans.push(100);
            /*else if (plan.type == "webinar500_monthly")
              this.ZoomPlans.push(500);*/ else if (
              plan.type == "webinar1000_monthly"
            )
              this.ZoomPlans.push(1000);
            else if (plan.type == "webinar3000_monthly")
              this.ZoomPlans.push(3000);
          }
        });
      }
    });
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule(
        "attendeeManagement",
        moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    }
    this.getAttendees();
    if (!moduleSpeakerManagement.isRegistered) {
      this.$store.registerModule("speakerManagement", moduleSpeakerManagement);
      moduleSpeakerManagement.isRegistered = true;
    }
    this.getSpeakers();
    if (!moduleTrackManagement.isRegistered) {
      this.$store.registerModule("trackManagement", moduleTrackManagement);
      moduleTrackManagement.isRegistered = true;
    }
    this.getTracks();
    if (!moduleRoundTableManagement.isRegistered) {
      this.$store.registerModule(
        "roundtableManagement",
        moduleRoundTableManagement
      );
      moduleRoundTableManagement.isRegistered = true;
    }
    this.getRoundTables();
    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
    this.fetchClientPlanDetails();
    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
    this.fetch_event_data();
    if (!moduleAgendaManagement.isRegistered) {
      this.$store.registerModule("agendaManagement", moduleAgendaManagement);
      moduleAgendaManagement.isRegistered = true;
    }
    this.$store.dispatch("agendaManagement/fetchGroups").then(function (res) {
      vm.GroupList = res.map((row) => {
        return {
          GroupId: row.GroupId,
          GroupName: row.GroupName,
        };
      });
    });
  },
};
</script>